import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';
import { IconsModule } from '@epicuro-next/ataraxia/icons';
import { InfiniteScrollModule } from '@epicuro-next/ataraxia/infinite-scroll';
import {
  ScrollButtonsComponent,
  ScrollOrientation,
} from '@epicuro-next/ataraxia/scroll-buttons';
import { WheelHorizontalScrollDirective } from '@epicuro-next/ataraxia/wheel-horizontal-scroll';
import { dynamicElementsScrollableContainer } from '@epicuro-next/constants/dynamic-elements';
import { DontTreeShake } from '@epicuro-next/elements/core';
import { DynamicComponentRegister } from '@epicuro-next/platform/dynamic-components-registrator';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
@DynamicComponentRegister(dynamicElementsScrollableContainer)
@Component({
  imports: [
    CommonModule,
    IconsModule,
    InfiniteScrollModule,
    ScrollButtonsComponent,
    WheelHorizontalScrollDirective,
  ],
  selector: 'epc-scrollable-container',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './scrollable-container.component.html',
  styleUrls: ['./scrollable-container.component.scss'],
})
export class ScrollableContainerComponent {
  public readonly ScrollOrientation = ScrollOrientation;

  @Input() public icon?: IconProp;
  @Input() public title?: string;
  @Input() public showScrollButtons = false;
  @Input() public scrollOrientation: ScrollOrientation =
    ScrollOrientation.horizontal;
  @Input() public maxHeight = -1;
  @Input() public horizontalPadding = '1.25rem';
  @Input() public wheelHorizontalScrollEnabled = true;

  @Input() public offsetHeightMargin = 0;

  @HostBinding('style.padding-left')
  public get paddingLeftHostBinding(): string {
    return this.horizontalPadding;
  }

  @HostBinding('style.padding-right')
  public get paddingRightHostBinding(): string {
    return this.horizontalPadding;
  }

  public get maxHeightStyle(): string {
    return this.maxHeight > 0 ? `${this.maxHeight}px` : 'none';
  }

  public get isHorizontal(): boolean {
    return this.scrollOrientation === ScrollOrientation.horizontal;
  }

  public get isVertical(): boolean {
    return this.scrollOrientation === ScrollOrientation.vertical;
  }
}

DontTreeShake(ScrollableContainerComponent);
